import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from 'shared/selectors/jsonQuery';
import { selectAvailablePromo } from 'shared/selectors/specialPromos';

export const selectSpecialPromoValue = createSelector(
  [selectAvailablePromo, selectJsonQuery],
  (specialPromo, jsonQuery) => {
    return jsonQuery.geo && specialPromo
      ? jsonQuery.geo.value.some(value => value.type === 'builder' && value.id === specialPromo.developerId)
      : false;
  },
);
